import { Link } from "react-router-dom"
import Components from "../../../components"

const Dashboard = () => {
    return <div className="dashboard of-management">
        <Components.data.Calendar/>
    </div>
}

export default Dashboard